import React from 'react';
import cn from 'classnames';

import FLAG from 'config/flag.singleton';
import interleave from 'utils/arrays/interleave.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import flatMap from 'utils/functions/flatMap.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './FormError.module.scss';

const L = logger('FormError');

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const fromAnyToErrorLines = (value) => fromAnyToTrimmed(value instanceof Error ? value.message : value).split('\n');

const FormError = ({ value, tag: tagFromProps, name: nameFromProps, render: renderFromProps, variant: variantFromProps }) => {
  const tag = fromAnyToTrimmed(tagFromProps);
  const name = fromAnyToTrimmed(nameFromProps);
  const render = fromAnyToTrimmed(renderFromProps);
  const variant = fromAnyToTrimmed(variantFromProps) || 'input';

  const array = Array.isArray(value) ? value : [value];
  const lines = flatMap(fromAnyToErrorLines, array);

  if (!lines.filter(alwaysSame).length && render !== 'always') {
    // don't bother rendering if there isn't useful info
    return null;
  }

  const renderedLines = interleave(<br />, lines).map((line, index) => <React.Fragment key={createNodeKey({ tag, index })}>{line}</React.Fragment>);

  const contentsClasses = cn(CN.contents, CN[`${variant}VariantContents`]);

  if (USE_SPAM_LOG) L.debug('()', tag, lines);

  return (
    <div data-bem="FormError" data-tag={tag} data-field-name={name} className={CN.component}>
      <span data-bem="FormError__contents" data-tag={tag} data-field-name={name} className={contentsClasses}>
        {renderedLines}
      </span>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default FormError;
